module.exports = __webpack_public_path__ + "static/media/IMG_3761 EDITED.6a414fb1.JPG";